import { ParOfferPricingAttributeResponse } from '../../../services/pricing';
import { PropElemAttributeRequest } from '../../../services/proposal';

export function pricingAttributeToElementAttribute(
  attribute: ParOfferPricingAttributeResponse[]
): PropElemAttributeRequest[] {
  // SERV = serviceduration ==> ctecalculationtype
  // SERV = servicecalculationmethod ==> ctecalculationbasis
  // FIN = calculationmethod ==>ctecalculationtype

  //return (
  const list = attribute?.filter((el)=> el.flagaddauto===true)?.map((e: ParOfferPricingAttributeResponse) => {

      return {
        cteid: 0,
        cteattid: 0,
        attid: e.attid,
        atttype: e.atttype,
        atttypelabel: e.atttypelabel,
        tpid: e.tpid,
        tpname: e.tpname,
        tpreference: e.tpreference,
        tprole: e.tprole,
        attcode: e.attcode,
        attcodelabel: e.attcodelabel,
        attdirection: e.attdirection,
        attmethod: e.attmethod,
        attmethodlabel: e.attmethodlabel,
        attexternalreference: e.attexternalreference,
        attamountmethod: e.attamountmethod,
        attamountmethodlabel: e.attamountmethodlabel,
        attamount: e.attamountdefault,
        attamountmax: e.attamountmax,
        attamountmin: e.attamountmin,
        attcoef: e.attcoefdefault,
        attcoefmax: e.attcoefmax,
        attcoefmin: e.attcoefmin,
        attrate: e.attrate,
        attnbdays: e.attnbdays,
        flagaddmanual: e.flagaddmanual,
        flagupdate: e.flagupdate,
        flagdelete: e.flagdelete,
        requesttype: e.requesttype,
        requestreceivertype: e.requestreceivertype,
        requestreceiverroleprofile: e.requestreceiverroleprofile,
        requestreceiverid: e.requestreceiverid,
        proccode: e.proccode,
        taskid: e.taskid,
        proctaskid: 0,
        attstatus: 'INIT',
        attstatuslabel: e.statuslabel,
        nbmonthsmax: e.nbmonthsmax,
        nbmonthsdefault: e.nbmonthsmax,
        flagaddauto: e.flagaddauto,
        attcomment:e.attcomment,
        nbmonthsrequested:0,
        attamountrequested:0,
        attamountagreed:0,
        attlabel:e.attlabel,
      };

  });

  return list;
  //);
}
